import { useEffect, useRef, useState } from 'react';
import { arquitetaData } from '@/mocks/homeData';

export default function Arquiteta() {
  const ref = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setInView(true);
      },
      { threshold: 0.2 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="arquiteta"
      ref={ref}
      className="bg-cream py-28 md:py-36 lg:py-44"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-20">
        <div
          className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start transition-all duration-1000 ease-editorial ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Left — Photo */}
          <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
            <img
              src="https://static.readdy.ai/image/ac022146e5e324748b77e0d4e56bfc05/e272a270f42fd502695d625e360c433b.jpeg"
              alt="Stephanie Zarowny"
              className="w-full h-full object-cover object-top"
              loading="lazy"
            />
          </div>

          {/* Right — Text */}
          <div className="lg:self-start">
            <span className="font-body text-xs font-light uppercase tracking-[0.2em] text-brand-gray-light block mb-4">
              A arquiteta
            </span>

            <h2 className="font-display text-3xl md:text-4xl lg:text-[42px] font-extralight text-black tracking-tight mb-8 md:mb-10">
              Stephanie Zarowny
            </h2>

            <div className="space-y-5 max-w-[520px] mb-10 text-justify">
              {arquitetaData.paragraphs.map((p, i) => (
                <p
                  key={i}
                  className="font-body text-[13px] md:text-sm font-light text-brand-gray-body leading-[1.75]"
                >
                  {p}
                </p>
              ))}
            </div>

            <a
              href="#contato"
              onClick={(e) => {
                e.preventDefault();
                document
                  .querySelector('#contato')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center px-10 py-3.5 text-xs font-normal uppercase tracking-[0.1em] text-white bg-marrom hover:bg-cinza-marca transition-colors duration-300 whitespace-nowrap"
            >
              {arquitetaData.cta.toUpperCase()}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}